module.exports = __webpack_public_path__ + "img/13.5656cf5f.jpg";